<template>
  <PopupTemplate @close="closeCuponAmigoConsumido()">
    <div>
      <div class="cabecera">¡Descuento aplicado!</div>
      <p>
        Hemos renovado tu póliza {{ cupon.numPoliza }} y tu descuento ha sido
        aplicado
      </p>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
export default {
  props: {
    cuponInic: { type: String, required: true, default: null }
  },

  data() {
    return {
      cupon: this.cuponInic
    };
  },

  created() {
    console.log(this.cuponInic);
  },

  methods: {
    closeCuponAmigoConsumido() {
      this.$emit("closeInfoCuponAmigo");
    }
  }
};
</script>

<style lang="scss">
.cabecera {
  font-size: 120%;
  width: 15rem;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}
</style>
